import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section id=\"home\" class=\"h40 d-flex align-items-center bg-brand section-padding mt-5 mt-md-0\"><div class=\"container w3\"><div class=\"row justify-content-center text-center\"><div class=\"col-sm-12 col-lg-8\"><h1 class=\"title text-shadow\">Anuncia tu marca</h1></div></div></div></section>", 1)
const _hoisted_2 = {
  id: "work",
  class: "py-5 align-items-center"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col col-lg-8" }
const _hoisted_6 = { class: "text-justify px-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "text-secondary text-bold py-2" }, " Anuncia tu marca con nosotros ", -1)
const _hoisted_8 = { class: "text-orange-400" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" es la primer plataforma en España que ofrece a sus clientes tráfico calificado y listo para comprar/aplicar por tu producto o servicio. Nuestro sistema de eliminación nos permite enviar a un usuario únicamente cuando estamos seguros de que cumple con las características que nuestro cliente necesita. ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " Además, nuestros clientes únicamente nos pagan cuando los usuarios que enviamos se convierten en una venta, por lo que nunca perderás al anunciarte con nosotros ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " Si quieres más información, por favor llena este breve cuestionario: ", -1)
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = { class: "p-float-label p-input-icon-right" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user pr-1" }, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "p-error pl-2"
}
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = { class: "p-float-label p-input-icon-right" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope pr-1" }, null, -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("small", { class: "p-error pl-2" }, "Ingresa un correo válido.", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "p-error pl-2"
}
const _hoisted_23 = { class: "p-field" }
const _hoisted_24 = { class: "p-float-label p-input-icon-right" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone pr-1" }, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("small", { class: "p-error pl-2" }, "Ingresa un teléfono válido.", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "p-error pl-2"
}
const _hoisted_30 = { class: "p-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_TypeSwitch = _resolveComponent("TypeSwitch")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", null, [
                _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.name), 1),
                _hoisted_9
              ]),
              _hoisted_10,
              _hoisted_11
            ]),
            _createElementVNode("form", {
              name: "form",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.sendEmail(!_ctx.v$.$invalid)), ["prevent"])),
              class: "pt-2"
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_InputText, {
                    type: "text",
                    id: "name",
                    modelValue: _ctx.v$.name.$model,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
                    class: _normalizeClass({ 'p-invalid': _ctx.v$.name.$invalid && _ctx.submitted }),
                    "aria-describedby": "name-error"
                  }, null, 8, ["modelValue", "class"]),
                  _createElementVNode("label", {
                    for: "name",
                    class: _normalizeClass(["pl-2", { 'p-error': _ctx.v$.name.$invalid && _ctx.submitted }])
                  }, "Nombre completo", 2)
                ]),
                (
                    (_ctx.v$.name.$invalid && _ctx.submitted) ||
                      _ctx.v$.name.$pending.$response
                  )
                  ? (_openBlock(), _createElementBlock("small", _hoisted_15, "Este campo es obligatorio."))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_InputText, {
                    id: "email",
                    modelValue: _ctx.v$.email.$model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
                    class: _normalizeClass({ 'p-invalid': _ctx.v$.email.$invalid && _ctx.submitted }),
                    "aria-describedby": "email-error"
                  }, null, 8, ["modelValue", "class"]),
                  _createElementVNode("label", {
                    for: "email",
                    class: _normalizeClass(["pl-2", { 'p-error': _ctx.v$.email.$invalid && _ctx.submitted }])
                  }, "Correo electrónico", 2)
                ]),
                (_ctx.v$.email.$invalid && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_21))
                  : (
                    (_ctx.v$.email.$invalid && _ctx.submitted) ||
                      _ctx.v$.email.$pending.$response
                  )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_22, "Este campo es obligatorio."))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_InputMask, {
                    modelValue: _ctx.v$.phone.$model,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.phone.$model) = $event)),
                    mask: "9999999999",
                    class: _normalizeClass({ 'p-invalid': _ctx.v$.phone.$invalid && _ctx.submitted }),
                    "aria-describedby": "phone-error",
                    autoClear: false
                  }, null, 8, ["modelValue", "class"]),
                  _createElementVNode("label", {
                    for: "phone",
                    class: _normalizeClass(["pl-2", { 'p-error': _ctx.v$.phone.$invalid && _ctx.submitted }])
                  }, "Teléfono", 2)
                ]),
                (_ctx.v$.phone.$invalid && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _hoisted_28))
                  : (
                    (_ctx.v$.phone.$invalid && _ctx.submitted) ||
                      _ctx.v$.phone.$pending.$response
                  )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_29, "Este campo es obligatorio."))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_TypeSwitch, {
                  "answer-key": "ProductId",
                  isRequired: false,
                  isSubmitted: _ctx.submitted,
                  catalog: "Product",
                  onGetValue: _ctx.setValue
                }, null, 8, ["isSubmitted", "onGetValue"])
              ]),
              _createVNode(_component_Button, {
                type: "submit",
                label: "Enviar",
                class: "p-button-raised p-button-rounded",
                loading: _ctx.loading
              }, null, 8, ["loading"])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}